var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLive = function SvgLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M5.018 3.355 7.99 5.6 5.018 7.844V3.355zM16 1.493v8.35c0 .283-.11.522-.33.72a1.04 1.04 0 0 1-.677.239.964.964 0 0 1-.622-.221l-2.472-1.917v.663a2.03 2.03 0 0 1-.613 1.484c-.409.412-.9.618-1.474.618H2.087a2.003 2.003 0 0 1-1.474-.618A2.03 2.03 0 0 1 0 9.327V2.102C0 1.524.205 1.029.613.617 1.023.206 1.513 0 2.087 0h7.725c.574 0 1.065.206 1.474.617.409.412.613.907.613 1.485v.57L14.371.757a.968.968 0 0 1 .622-.221c.281 0 .519.095.714.285a.91.91 0 0 1 .293.673zM9.565 5.644c0-1.975-1.59-3.576-3.552-3.576S2.462 3.669 2.462 5.644 4.052 9.22 6.013 9.22c1.962 0 3.552-1.6 3.552-3.576z"
  })));
};
export default SvgLive;